var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.594 392.25L177.592 504.32C168.094 514.559 151.905 514.559 142.405 504.32L38.405 392.25C31.92 385.258 30.186 375.066 34 366.312C37.811 357.555 46.452 351.895 55.998 351.895H120V40C120 17.906 137.907 0 160 0S200 17.906 200 40V351.895H264C273.547 351.895 282.188 357.555 286.002 366.312C289.813 375.066 288.079 385.258 281.594 392.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLong);
export default __webpack_public_path__ + "static/media/down-long.f07c3e0819d3a1f1bab1b3e7eba91474.svg";
export { ForwardRef as ReactComponent };